import "./Casebanner.css";

function CasebannerLoading() {
  return (
    <section id="case-banner">
      <div className="case-banner-skeleton">
        <div className="shimmer-dark case-banner-skeleton-title" />
        <div className="shimmer-dark case-banner-skeleton-intro" />
        <div className="case-banner-skeleton-row">
          <div className="shimmer-dark case-banner-skeleton-tag" />
          <div className="shimmer-dark case-banner-skeleton-tag" />
        </div>
      </div>
    </section>
  );
}

export default CasebannerLoading;
